/**
 * Includes for the payin invoice view experience in Admin
 *
 * @type {string[]}
 */
export const PAYIN__SH_INVOICE_INCLUDES = [
  'actions',
  'actions.user',
  'application',
  'application.company',
  'application.cost-code',
  'company',
  'child-sh-invoices.application',
  'child-sh-invoices.sh-invoice-line-items.application',
  'child-sh-invoices.sh-invoice-line-items.project-line-item',
  'child-sh-invoices.sh-invoice-transactions',
  'child-sh-invoices.sh-payment',
  'fee-structure',
  'parent-sh-invoice',
  'sh-invoice-line-items.application',
  'sh-invoice-line-items.project-line-item',
  'sh-invoice-transactions',
  'sh-payment'
];

/**
 * Constants for the menu items in the table that are sortable.
 *
 * @type {Object}
 */
export const PAYIN__SORT_ATTRIBUTES = {
  COMPANY: 'company_id'
};

/**
 * The column names for the payin invoice table.
 *
 * @type {string[]}
 */
export const PAYIN__COLUMN_HEADERS = [
  'Invoice Ids',
  'Child Invoice Ids',
  'Company',
  'Cost Code',
  'Description',
  'Project',
  'Amount',
  'Due At',
  'Final At',
  'Revised At',
  'Paid Status',
  'Sent At'
];
